<style lang="scss" scoped>
.car-picture-container {
  width: 100%;
  min-height: 100vh;
  background-color: #101116;
  padding-top: 236px;
  background-image: url('https://oss.turingsenseai.com/1606981447569976463.png');
  background-repeat: no-repeat;
  background-size: 100% 472px;
  background-position: 0 36px;
  // .car-bg {
  //   position: absolute;
  //   top: 36px;
  //   height: 472px;
  //   width: 100%;
  //   background-image: url('https://oss.turingsenseai.com/1606981447569976463.png');
  //   background-repeat: no-repeat;
  //   background-size: 100% auto;
  //   z-index: 1;
  // }
  .img-container {
    width: 452px;
    height: 452px;
    border: 2px solid rgba($color: #ffffff, $alpha: 0.26);
    box-shadow: inset 0 0 53px 0 rgba($color: #000000, $alpha: 0.17);
    border-radius: 8px;
    overflow: hidden;
    background-color: rgba($color: #000000, $alpha: 0.2);
    margin: 0 auto;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    position: relative;
    .car-container {
      // width: 100%;
      // height: 100%;
      position: relative;
      top: 50%; 
      left: 50%; 
      transform: translateX(-50%) translateY(-50%); 
      position: relative;
      .car-img {
        height: 100%;
        width: 100%;
        object-fit: contain;
        position: absolute;
      }
      .mark, .part {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        // font-size: 
        // border: 1px solid red;
        // top: 40px;
        // left: 50px;
        // width: 50px;
        // height: 70px;
        // transform: translateX(-50%);
        .part-name {
          position: absolute;
          top: 0;
          left: 0;
          transform: translateY(-100%);
          font-size: 24px;
        }
      }
      
    }

    .plus-icon, .err-icon {
      width: 68px;
      height: 66px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
    .assesting-tip {
      color: #ffffff;
      font-size: 24px;
      line-height: 34px;
      position: absolute;
      height: 250px;
      width: 250px;
      background-color: rgba($color: #000000, $alpha: 0.7);
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }
  .tips {
    font-size: 20px;
    color: #ffcb46;
    margin-top: 32px;
    line-height: 28px;
    text-align: center;
  }
  .reset {
    width: 604px;
    height: 224px;
    margin: 32px auto 0;
    background-image: url('https://oss.turingsenseai.com/1606987787252752913.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    line-height: 168px;
    font-size: 34px;
    color: #ffffff;
    text-align: center;
    position: relative;
  }
  .slogan {
    position: absolute;
    bottom: 128px;
    left: 50%;
    transform: translateX(-50%);
    width: 696px;
    height: 122px;
    background-image: url('https://oss.turingsenseai.com/1606981270364399254.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .screen {
    position: fixed;
    height: 100vh;
    width: 100vw;
    background-color: rgba($color: #000000, $alpha: 0.8);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .screen-img-container {
      width: 750px;
      height: 750px;
      border: 1px solid rgba(#fff, $alpha: 0.26);
      .screen-car-container {
        position: relative;
        top: 50%; 
        left: 50%; 
        transform: translateX(-50%) translateY(-50%); 
        position: relative;
        .screen-car-img {
          height: 100%;
          width: 100%;
          object-fit: contain;
          position: absolute;
        }
        .screen-mark, .screen-part {
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          .screen-part-name {
            position: absolute;
            top: 0;
            left: 0;
            transform: translateY(-100%);
            font-size: 24px;
          }
        }
      }
    }
  }
}
</style>

<template>

  <div class="car-picture-container">
    <!-- <div class="car-bg"></div> -->
    <div ref="imgContainer" class="img-container" @touchend="selectPicture">
      <div v-if="imageUrl" class="car-container" :style="imgStyle">
        <img ref="uploadImg" :src="imageUrl" class="car-img">
        <div v-for="(part, index) in partList" :key="index" :style="part.style" class="part">
          <div class="part-name">{{part.name}}</div>
        </div>
        <div v-for="(mark, index) in markList" :key="index + partList.length" :style="mark.style" class="mark">
          {{mark.name}}
        </div>
        
        <!-- <div class="mark" style="color: red"></div> -->
      </div>
      <img v-if="state === 1" class="plus-icon" src="https://oss.turingsenseai.com/1606981982408798355.png">
      
      <img v-if="state === 3" class="err-icon" src="https://oss.turingsenseai.com/1606981958656451482.png">
      <div v-if="state === 2" class="assesting-tip">损伤识别中...</div>
    </div>
    <div v-if="state === 1 || state === 2" class="tips">Tips: 请上传一张清晰的车辆细节图~</div>
    <div v-if="state === 3" class="tips">图片不符合规范</div>
    <div v-if="state === 5" class="tips">识别结束，未检测到受损部位</div>

    <div v-if="imageUrl" class="reset"  @touchend="resetImage">重新上传</div>

    <div class="slogan"></div>

    <input style="display: none" ref="picture" type="file" accept="image/*" @change="filesChange" />

    <div v-if="showPreview" class="screen" @touchend="closeScreen">
      <div class="screen-img-container">
        <div v-if="imageUrl" class="screen-car-container" :style="screenImgStyle">
          <img :src="imageUrl" class="screen-car-img">
          <div v-for="(part, index) in partList" :key="index" :style="part.previewStyle" class="screen-part">
            <div class="screen-part-name">{{part.name}}</div>
          </div>
          <div v-for="(mark, index) in markList" :key="index + partList.length" :style="mark.previewStyle" class="screen-mark">
            {{mark.name}}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { uploadImage } from './../../common/api/common'
import { Toast } from 'vant'

// 发起http请求
function assestCarRequest (type, url) {
  return new Promise((resolve, reject) => {
      fetch(
        `https://ktm.turingsenseai.com/api/v1`,
        {
          method: 'POST',
          responseType: 'json',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ type: 1, image_url: url })
        }
      ).then(async res => {
        const { status: httpStatus } = res;
        const resObj = await res.json();
        console.log('=============》', resObj)
        resolve(resObj);
    }, () => {
      reject(new Error('error'))
    }).catch(() => {
      reject(new Error('error'))
    })

    // setTimeout(() => {
    //   resolve({
    //     errno: 0,
    //     err_msg: '正确',
    //     result: [{
    //       part_name: 'FaDongJiGai', // 损伤部件名，详见损伤部件列表
    //       part_position: { // 部件部分在图片中的位置
    //         'xmin': 42,
    //         'ymin': 58,
    //         'xmax': 80,
    //         'ymax': 108,
    //       },
    //       damage_level: 'posun', // 损伤级别，详见损伤级别列表
    //       damage_position: [{ // 损伤部分在图片中的位置
    //         'xmin': 57,
    //         'ymin': 68,
    //         'xmax': 70,
    //         'ymax': 90,
    //       }],
    //       score: 0.25676767698998
    //     }]
    //   })
    // }, 1000)
  })
}

const PART_NAME = {
  AZhu_damage: 'A柱',
  DiDaBian_damage: '底大边',
  FaDongJiGai_damage: '发动机盖',
  GangQuan_damage: '钢圈',
  XingLiXiangGai_damage: '行李箱盖',
  HouBaoXianGangPi_damage: '后保险杠皮',
  HouCheMenKe_damage: '后车门壳',
  HouShiJing_damage: '后视镜',
  HouYeZiBan_damage: '后叶子板',
  QianBaoXianGangPi_damage: '前保险杠皮',
  QianCheMenKe_damage: '前车门壳',
  QianDaDeng_damage: '前大灯',
  QianYeZiBan_damage: '前叶子板',
  WaiWeiDeng_damage: '外尾灯',
  ZhongWang_damage: '中网',
}

const DAMAGE_LEVEL = {
  huaheng: { name: '划痕', color: '#FEFF3E' },
  guaca: { name: '刮擦', color: '#3BE096' },
  posun: { name: '破损', color: '#027AFF' },
  xingbian: { name: '形变', color: '#F64C4C' },
}

const rate = 750 / 452;

export default {
  data () {
    return {
      // imageUrl: 'https://oss.turingsenseai.com/1606982437930013821.png',
      imageUrl: '',
      markList: [],
      partList: [],
      imgStyle: '',
      screenImgStyle: '',
      imageOrigin: {
        height: 0,
        width: 0,
      },
      imageActual: {
        height: 0,
        width: 0,
        max: 'width',
      },
      state: 1, // 1:未上传图片， 2：损伤识别中，  3：识别失败， 4：识别成功，有受损  5：识别成功，没有受损
      tips: 'Tips: 请上传一张清晰的车辆细节图~',
      showPreview: false
    }
  },
  methods: {
    selectPicture () {
      if (this.imageUrl) {
        this.showPreview = true;
        return
      }
      this.$refs.picture.click();
    },
    // 监听文件变化
    filesChange (e) {
      this.resetData();
      console.log(e.target.files);
      const fileList = e.target.files;
      if (fileList.length <= 0) return;
      const reader = new FileReader();
      reader.readAsDataURL(fileList[0]);
      reader.onload = (result) => {
        console.log(result);
        const imgB64 = result.target.result.split(',')[1];
        console.log(imgB64)
        this.uploadImg(imgB64);
      };
    },
    uploadImg (file) {
        const uploadToast = Toast.loading({
          message: '图片上传中...',
          forbidClick: true
        })
        uploadImage({ imgB64: file })
          .then(res => {
            if (res.errorCode === 0) {
              this.imageUrl = res.imageUrl
              // this.getSkcInfo(this.imageUrl)
              const img = new Image();
              img.src = res.imageUrl;
              img.onload = result => {
                console.log(img.width, img.height);
                const max = this.$refs.imgContainer.clientWidth;
                this.imageOrigin = {
                  height: img.height,
                  width: img.width,
                }
                if (img.width > img.height) {
                  this.imageActual = {
                    width: max,
                    height: (img.height / img.width) * max,
                    max: 'width'
                  }
                } else {
                  this.imageActual = {
                    width: (img.width / img.height) * max,
                    height: max,
                    max: 'height'
                  }
                }
                this.imgStyle = `width: ${this.imageActual.width}px; height: ${this.imageActual.height}px`;
                this.screenImgStyle = `width: ${this.imageActual.width * rate}px; height: ${this.imageActual.height * rate}px`;
                console.log(this.imgStyle);
                this.state = 2;
                this.assessCar(res.imageUrl);
              }
            }
          }).finally(() => {
            uploadToast.clear()
          })
    },
    assessCar (imageUrl) {
      assestCarRequest(1, imageUrl)
      .then(res => {
        console.log(res);
        if (res.errno === 0) {
          this.state = 4;
          if (res.results && res.results.length > 0) {
            // this.state = 4;
            const partObj = {};
            res.results.forEach((item, index) => {
              const max = this.imageActual[this.imageActual.max];
              const screenMax = document.body.clientWidth;
              console.log(this.imageActual, max);
              if (item.score < 0.25) return
              // 处理部件标记
              if (!partObj[item['part_name']]) {
                partObj[item['part_name']] = true;
                const part = item['part_position'];
                const partLeft = part['xmin'] / this.imageOrigin.width * this.imageActual.width;
                const partTop = part['ymin'] / this.imageOrigin.height * this.imageActual.height;
                const partHeight = (part['ymax'] - part['ymin']) / this.imageOrigin.height * this.imageActual.height;
                const partWidth = (part['xmax'] - part['xmin']) / this.imageOrigin.width * this.imageActual.width;
                this.partList.push({
                  style: `top: ${partTop}px; left: ${partLeft}px; height: ${partHeight}px; width: ${partWidth}px; border: 2px solid #fff; color: #fff`,
                  previewStyle: `top: ${partTop * rate}px; left: ${partLeft * rate}px; height: ${partHeight * rate}px; width: ${partWidth * rate}px; border: 2px solid #fff; color: #fff`,
                  name: PART_NAME[item['part_name']]
                })

                // this.screenPartList.push({
                //   style:
                // })
              }
              // 处理损伤标记
              const damage = item['damage_position'];
              const left = damage['xmin'] / this.imageOrigin.width * this.imageActual.width;
              const top = damage['ymin'] / this.imageOrigin.height * this.imageActual.height;
              const height = (damage['ymax'] - damage['ymin']) / this.imageOrigin.height * this.imageActual.height;
              const width = (damage['xmax'] - damage['xmin']) / this.imageOrigin.width * this.imageActual.width;
              this.markList.push({
                style: `top: ${top}px; left: ${left}px; height: ${height}px; width: ${width}px; border: 1px solid ${DAMAGE_LEVEL[item['damage_level']].color}; color: ${DAMAGE_LEVEL[item['damage_level']].color}`,
                previewStyle: `top: ${top * rate}px; left: ${left * rate}px; height: ${height * rate}px; width: ${width * rate}px; border: 1px solid ${DAMAGE_LEVEL[item['damage_level']].color}; color: ${DAMAGE_LEVEL[item['damage_level']].color}`,
                name: DAMAGE_LEVEL[item['damage_level']].name
              })
            })
          } else {
            this.state = 5
          }
          console.log(this.markList, this.imageOrigin);
        } else {
          this.state = 3
        }
      }, () => {
        this.state = 3
      }).catch(() => {
        this.state = 3
      })
    },
    resetImage () {
      this.$refs.picture.click()
    },
    closeScreen () {
      this.showPreview = false
    },
    resetData () {
      this.markList = [];
      this.partList = [];
      // imgStyle: 'height:105px; width: 224px; ',
      this.mageOrigin = {
        height: 0,
        width: 0,
      };
      this.imageActual = {
        height: 0,
        width: 0,
        max: 'width',
      };
      this.imageUrl = '';
      this.imgStyle = '';
      this.screenImgStyle = '';
      this.state = 1;
    }
  },
  mounted () {
    // console.log(this.$refs.uploadImg.width);
    // console.log(this.$refs.uploadImg.height);
    // console.log(this.$refs.imgContainer.clientWidth);

    // setTimeout(() => {
    //   this.imgStyle = 'height:105px; width: 224px; top: 50%; left: 50%; transform: translateX(-50%) translateY(-50%); position: relative'
    //   this.assessCar(this.imageUrl)
    // })
  }
}
</script>
